module.exports = __webpack_public_path__ + "img/close.ce64da97.svg";